import type { Schema } from "@/shared/components/Form/types";
import type { EditSchemaDefinition } from "@/shared/components/CRUD/types";
import { ContentShowQuery } from "@/admin/entities/contents";
import type { ContentShowQueryQueryType } from "@/types/graphql/admin.generated";
import { PlatformsAutocompleteQuery } from "@/admin/entities/platforms";

/**
 * Схемы форм для feature управления контентом
 * Контент только просматривается и удаляется/восстанавливается — редактирования нет
 */

// Фильтры списка контента
export const filterSchema: Schema = {
  search: {
    label: "Поиск",
    type: "text",
    placeholder: "Поиск по названию...",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "primary",
  },
  platformId: {
    label: "Платформа",
    type: "autocomplete",
    query: PlatformsAutocompleteQuery,
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
  },
  deleted: {
    label: "Показывать удалённые",
    type: "switch",
    priority: "secondary",
    xs: 12,
    md: 6,
    fullWidth: true,
  },
};

// Схема просмотра контента (read-only, редактирования нет)
export const editSchema: EditSchemaDefinition = {
  details: {
    label: "Детали",
    type: "show" as const,
    getTitle: (data: unknown) => {
      const { content } = data as ContentShowQueryQueryType;
      if (!content) return null;
      return content.title;
    },
    showQuery: ContentShowQuery,
  },
} as const;
